// extracted by mini-css-extract-plugin
var _1 = "ApplicantProfileWidgetStageScreeningGroup-moduleApplicantProfileWidgetStageScreeningGroup__qyb05";
var _2 = "ApplicantProfileWidgetStageScreeningGroup-modulechecks__V5B4G";
var _3 = "ApplicantProfileWidgetStageScreeningGroup-moduletitle__cw_sY";
export { _1 as "ApplicantProfileWidgetStageScreeningGroup", _2 as "checks", _3 as "title" }
